// ArrayBuffer -> base64
export function arrayBufferToBase64(buffer: ArrayBuffer): string {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
}

// Hibrit şifreleme: AES ile veri, RSA ile anahtar
export async function encryptPaymentInfoHybrid(
  cardInfo: any,
  publicKeyPem: string
): Promise<{ encryptedData: string; encryptedAesKey: string; iv: string }> {
  // 1. Public key'i import et
  const pemHeader = '-----BEGIN PUBLIC KEY-----';
  const pemFooter = '-----END PUBLIC KEY-----';
  const pemContents = publicKeyPem
    .replace(pemHeader, '')
    .replace(pemFooter, '')
    .replace(/\s/g, '');

  const binaryDer = Uint8Array.from(atob(pemContents), c => c.charCodeAt(0));

  const rsaKey = await window.crypto.subtle.importKey(
    'spki',
    binaryDer.buffer,
    {
      name: 'RSA-OAEP',
      hash: 'SHA-256'
    },
    false,
    ['encrypt']
  );

  // 2. AES anahtarı oluştur
  const aesKey = await window.crypto.subtle.generateKey(
    { name: 'AES-GCM', length: 256 },
    true,
    ['encrypt', 'decrypt']
  );

  // 3. Veriyi encode et
  const encoder = new TextEncoder();
  const encoded = encoder.encode(JSON.stringify(cardInfo));

  // 4. IV oluştur
  const iv = window.crypto.getRandomValues(new Uint8Array(12));

  // 5. Veriyi AES ile şifrele
  const encryptedDataBuffer = await window.crypto.subtle.encrypt(
    { name: 'AES-GCM', iv },
    aesKey,
    encoded
  );

  // 6. AES anahtarını export et
  const rawAesKey = await window.crypto.subtle.exportKey('raw', aesKey);

  // 7. AES anahtarını RSA ile şifrele
  const encryptedAesKeyBuffer = await window.crypto.subtle.encrypt(
    { name: 'RSA-OAEP' },
    rsaKey,
    rawAesKey
  );

  // 8. Base64'e çevir
  return {
    encryptedData: arrayBufferToBase64(encryptedDataBuffer),
    encryptedAesKey: arrayBufferToBase64(encryptedAesKeyBuffer),
    iv: arrayBufferToBase64(iv.buffer)
  };
}

